var map = {
	"./b_b.png": 80,
	"./b_w.png": 81,
	"./k_b.png": 82,
	"./k_w.png": 83,
	"./n_b.png": 84,
	"./n_w.png": 85,
	"./p_b.png": 86,
	"./p_w.png": 87,
	"./q_b.png": 88,
	"./q_w.png": 89,
	"./r_b.png": 90,
	"./r_w.png": 91
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50;